import { render, staticRenderFns } from "./ChannelRowVirtualItem.vue?vue&type=template&id=320d8672&scoped=true&"
import script from "./ChannelRowVirtualItem.vue?vue&type=script&lang=js&"
export * from "./ChannelRowVirtualItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d8672",
  null
  
)

export default component.exports